import { EditOutlined } from "@ant-design/icons";
import { MarkChatReadOutlined } from "@mui/icons-material";
import { Button, Tag, Tooltip, message } from "antd";
import { toJalaali } from "jalaali-js";
import { memo, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../api/api";
import DataTable from "../../../Components/DataTable/DataTable";
import { normalizeVariableList } from "../../../Util/smsTemplateVariables";
import styles from "./SmsTemplates.module.css";

const SmsTemplates = () => {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState([]);

  const columns = [
    {
      title: "عنوان",
      dataIndex: "title",
      searchable: true,
    },
    {
      title: "کلید",
      dataIndex: "key",
      searchable: true,
      render: (value) => <span dir="ltr">{value}</span>,
    },
    {
      title: "متغیرها",
      dataIndex: "valid_variables",
      render: (value) => {
        const variables = normalizeVariableList(value);
        if (!variables.length) return "—";
        return (
          <div className={styles.tags}>
            {variables.map((name) => (
              <Tag key={name}>
                <span dir="ltr">{`$${name}$`}</span>
              </Tag>
            ))}
          </div>
        );
      },
    },
    {
      title: "متن",
      dataIndex: "text",
      render: (value) => <div className={styles.text}>{value}</div>,
    },
    {
      title: "آخرین ویرایش",
      dataIndex: "updatedAt",
      render: (text) => {
        if (!text || text === "-") return null;
        const date = new Date(text);
        const jalali = toJalaali(
          date.getFullYear(),
          date.getMonth() + 1,
          date.getDate()
        );
        return (
          <span dir="ltr">
            {jalali.jy}-{jalali.jm}-{jalali.jd}{" "}
            {date.toLocaleTimeString("eo", { hour12: false })}
          </span>
        );
      },
    },
    {
      title: "عملیات",
      render: (_, record) => (
        <Tooltip title="ویرایش">
          <Button
            icon={<EditOutlined />}
            type="primary"
            onClick={() => navigate("/sms-templates/edit/" + record.id)}
          />
        </Tooltip>
      ),
    },
  ];

  useEffect(() => {
    loadTemplates();
  }, []);

  const loadTemplates = () => {
    api
      .get("/smstemplate/list")
      .then((res) => {
        setTemplates(Array.isArray(res.data) ? res.data : []);
      })
      .catch((error) => {
        message.error(
          error.response?.data?.error?.message || "خطا در دریافت قالب‌ها"
        );
      });
  };

  return (
    <DataTable
      id="SmsTemplates"
      dataSource={templates}
      setDataSource={setTemplates}
      columns={columns}
      reload={loadTemplates}
      recordCreatorDisabled
      header={{
        title: "قالب‌های پیامک",
        avatar: { icon: <MarkChatReadOutlined />, size: "large" },
      }}
    />
  );
};

export default memo(SmsTemplates);
